import { render, staticRenderFns } from "./ExchangeForm.vue?vue&type=template&id=d2bf6cf8&scoped=true"
import script from "./ExchangeForm.vue?vue&type=script&lang=js"
export * from "./ExchangeForm.vue?vue&type=script&lang=js"
import style0 from "./ExchangeForm.vue?vue&type=style&index=0&id=d2bf6cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bf6cf8",
  null
  
)

export default component.exports